import React, { useEffect, useState } from 'react';
import api from '../../services/api';
import Spinner from '../Common/Spinner';
import { DataGrid } from '../Common/DataGrid';
import CreateActionItemModal from './CreateActionItemModal';
import { FiPlus } from 'react-icons/fi';
import { formatDateDDMMMYYYY } from '../../utils/dateFormat';
import './ActionItem.css';

const ActionItemList = () => {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [createModalOpen, setCreateModalOpen] = useState(false);

  useEffect(() => {
    api.get('/action-items')
      .then(res => setItems(res.data))
      .finally(() => setLoading(false));
  }, []);

  const handleCreateActionItem = () => {
    setCreateModalOpen(true);
  };

  const handleCreateModalSave = (formData) => {
    // TODO: wire to API when backend is ready
    console.log('Create Issue:', formData);
  };

  if (loading) return <Spinner />;

  return (
    <div>
      <div className="action-item-list-header">
        <h2 className="action-item-list-title">Issue</h2>
        <button
          type="button"
          className="btn btn-primary btn-icon-only"
          onClick={handleCreateActionItem}
          title="Create Issue"
          aria-label="Create Issue"
        >
          <FiPlus size={20} aria-hidden />
        </button>
      </div>

      <CreateActionItemModal
        isOpen={createModalOpen}
        onClose={() => setCreateModalOpen(false)}
        onSave={handleCreateModalSave}
        defaultProject={null}
        defaultSiteId=""
        pi="Dr. Tapan Shah"
      />

      <DataGrid
        data={items}
        searchPlaceholder=""
        searchKeys={['actionItemNumber', 'findingDescription', 'section', 'severity', 'priorityDescription', 'status', 'siteID', 'siteId', 'siteCode', 'SiteCode', 'vSiteCode', 'siteDescription', 'SiteDescription']}
        defaultPageSize={10}
        emptyMessage="No issues found."
        columns={[
          { key: 'actionItemNumber', label: 'Issue No' },
          { key: 'siteID', label: 'Site' },
          { key: 'section', label: 'Section' },
          { key: 'priorityDescription', label: 'Priority' },
          { key: 'findingDescription', label: 'Description' },
          { key: 'status', label: 'Status' },
          { key: 'dueDate', label: 'Due Date' },
          { key: 'daysOpen', label: 'Days Open' },
        ]}
        renderRow={(item) => (
          <tr key={item.actionItemID}>
            <td>{item.actionItemNumber}</td>
            <td>{item.siteCode ?? item.SiteCode ?? item.vSiteCode ?? item.siteID ?? item.siteId ?? '—'}</td>
            <td>{item.section}</td>
            <td>
              <span className={`badge badge-${((item.priorityDescription || item.severity || '') || '').toLowerCase().replace(/\s+/g, '')}`}>
                {item.priorityDescription ?? item.severity ?? '—'}
              </span>
            </td>
            <td>{item.findingDescription}</td>
            <td>
              <span className={`badge badge-${(item.status || '').toLowerCase()}`}>
                {item.status}
              </span>
            </td>
            <td>
              {item.dueDate ? formatDateDDMMMYYYY(item.dueDate) : '-'}
            </td>
            <td>{item.daysOpen}</td>
          </tr>
        )}
      />
    </div>
  );
};

export default ActionItemList;
